module.exports = __webpack_public_path__ + "img/chat-left-quote-fill.f3018def.svg";